import { Box, InputProps, useRecipe } from '@chakra-ui/react';
import React, { FunctionComponent as FC } from 'react';

interface MCustomInputWrapperProps extends InputProps {}

const MCustomInputWrapper: FC<MCustomInputWrapperProps> = React.forwardRef<
  any,
  MCustomInputWrapperProps
>((props: MCustomInputWrapperProps, ref: any) => {
  const { size, variant, children, ...rest } = props;
  const inputRecipe = useRecipe({ key: 'input' });
  const styles = inputRecipe({ variant, size });

  return (
    <Box ref={ref} css={styles} {...rest}>
      {children}
    </Box>
  );
});

export default MCustomInputWrapper;
